<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="request-modal-title"> {{'requestproduct' | language : 'Request Product '}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-btn">
        <span>{{'cancel' | language : 'cancel'}}</span>
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding add-product-layout">
  <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
    <div class="custom-file-input">
      <input type="file" (change)="onFileSelected($event, 'productImage')" id="productImage" accept="image/*"
        class="d-none" />
      <label for="productImage" class="custom-label">
        <ion-icon *ngIf="!imagePreview['productImage']" name="image-outline" class="media-icons"></ion-icon>
        <p *ngIf="!imagePreview['productImage']"> {{'Clicktobrowseimage' | language : 'Click to browse image'}}</p>
        <img *ngIf="imagePreview['productImage']" [src]="imagePreview['productImage']" alt="Image 2 Preview"
          class="preview-img" />
      </label>
    </div>
    <ion-label class="input-label">
      {{'selectcategory' | language : 'Select Category '}}
    </ion-label>
    <ion-item class="input-element" lines="none" (click)="openSelectCategoryModal()">
      <ion-img class="category-food-img" [src]="selectedCategoryImage || 'assets/images/foodproduct.svg'"></ion-img>
      <ion-input class="inputField" type="text" placeholder="Select" formControlName="category"></ion-input>
      <ion-icon name="add-outline"></ion-icon>
    </ion-item>
    <div
      *ngIf="requestForm.get('category').invalid && (requestForm.get('category').dirty || requestForm.get('category').touched)">
      <span *ngIf="requestForm.get('category').errors?.required" class="error-message">
        {{'categoryisrequired' | language : 'Category is required. '}}</span>
    </div>
    <ion-label class="input-label">{{'productName' | language : 'Product Name'}}</ion-label>
    <ion-item class="input-element" lines="none">
      <ion-input class="inputField" type="text" formControlName="productName"></ion-input>
    </ion-item>
    <div
      *ngIf="requestForm.get('productName').invalid && (requestForm.get('productName').dirty || requestForm.get('productName').touched)">
      <span *ngIf="requestForm.get('productName').errors?.required" class="error-message">
        {{'productnameisrequired' | language : 'Product Name is required.'}}
      </span>
    </div>
    <ion-label class="input-label"> {{'description(optional)' | language : 'Description (Optional)'}}</ion-label>
    <ion-item class="textarea" lines="none">
      <ion-textarea class="inputField" rows="4" formControlName="description"></ion-textarea>
    </ion-item>
  </form>
</ion-content>
<ion-footer class='add-product-footer'>
  <ion-buttons class="submit-btn-group">
    <ion-button class="submit-btn" [ngClass]="{'active': requestForm.valid, 'inactive': !requestForm.valid}"
      expand="full" (click)="onSubmit(); moveToCatalog()">
      <ion-icon name="checkmark-outline" size="large"></ion-icon>
      {{"submit" | language: "Submit"}}
    </ion-button>
    <ion-button *ngIf="requestForm.valid" class="submit-btn add-btn" expand="full" (click)="onSubmit()">
      <ion-icon name="add" size="large"></ion-icon>
      {{'submit&add' | language : 'Submit & Add '}}
    </ion-button>
  </ion-buttons>
</ion-footer>